<template>
  <div style="margin: auto">
    <!-- Logo -->
    <div class="mb-4 text-center">
      <img :src="image" alt="Takaful Brunei" style="width: 50%" />
    </div>
    <div style="width: 530px" class="col-12">
      <div class="card mb-4 text-center p-2">
        <div class="card-body">

          <!-- Form -->
          <!-- <h1 class="mb-3 text-18">Login</h1> -->
          <div class="form-group mb-5">
            <label class="mb-1" for="email">Please enter the OTP sent to your email.</label>
            <input
              class="form-control"
              type="text"
              name="otp"
              id="otp"
              v-model="data.code"
              autocomplete="off"
            />
          </div>

          <!-- Button -->
          <button
            :disabled="disableBtn"
            @click="submitOtp"
            class="btn btn-primary btn-block mt-4 mb-1"
          >
            Submit OTP
          </button>

          <!-- Resend OTP -->
          <div class="mb-3">
            <div class="clickable-text" @click="resendOtp" @mouseover="isHovered = true" @mouseleave="isHovered = false">
              Resend OTP
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Auth from "@/services/Auth";
import axios from "axios";

let auth = new Auth();

export default {
  name: "login",
  components: {},

  data() {
    return {
      data: {
        code: null,
      },
      disableBtn: false,
      image: require("@/assets/icons/logo-tb.png"),
    };
  },

  methods: {
    async submitOtp() {
      this.disableBtn = true;
      try {
        let response = await axios.post("auth/validate",
          this.data,
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`
            }
          }
        )

        let roles = sessionStorage.getItem('roles');

        if(response.data.success == true) {
          localStorage.setItem("user", sessionStorage.getItem('preUser'));
          localStorage.setItem("token", sessionStorage.getItem('preToken'));
        }

        swal({
          icon: response.data.success == true ? 'success' : 'error',
          text: response.data.message
        }).then((result) => {
          this.disableBtn = false;
          if(result && response.data.success) {
            if(roles == "Vendor") {
              this.removeStorage();
              window.location = "banner";
              return;
            }
            this.removeStorage();
            window.location = "dashboard";
          }
        });

      } catch (error) {
        console.log(error.message);
        swal({
          icon: 'error',
          text: error.message
        });
        this.disableBtn = false;
      }
    },

    async resendOtp() {
      try {
        let response = await axios.post("auth/resend",
          {},
          {
            headers: {
              Authorization: `Bearer ${this.getToken()}`
            }
          }
        )

        swal({
          icon: response.data.success == true ? 'success' : 'error',
          text: response.data.message
        })
      } catch (e) {
        console.log(error.message);
        swal({
          icon: 'error',
          text: error.message
        }).then((result) => {
          if(result && sessionStorage.getItem('preToken') == null) {
            this.$router.push("login");
          }
        })
      }
    },

    getToken() {
      let token = sessionStorage.getItem('preToken');

      if(token == null || token == "") {
        return;
      }

      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    removeStorage() {
      sessionStorage.removeItem("preToken");
      sessionStorage.removeItem("preUser");
      sessionStorage.removeItem("roles");
    }
  },

  mounted() {
    if(sessionStorage.getItem('preToken') == null) {
      this.$router.push("login");
    }
  },
};
</script>


<style>
.clickable-text {
  cursor: pointer;
}

.clickable-text:hover {
  /* Add your hover effect styles here */
  text-decoration: underline;
}
</style>
